import React from "react";
import AdminReviews from "../../../components/admin/reviews/reviews";
import AdminTemplate from "../../../templates/admin-template";
const AdminReviewsPage = () => {
  return (
    <AdminTemplate>
      <AdminReviews />
    </AdminTemplate>
  );
};
export default AdminReviewsPage;